import React from 'react';

export default class HelloPage extends React.Component {
  render() {
    return (
      <div>
        <a href="/">AJIO</a> says Hello !!!
      </div>
    );
  }
}
